import axios from '../utils/axios';

export default function downloadCourseViewLeads(adminId,courseId,params) {
    return (
        axios.get('/admin/' + adminId +'/courses/course/' + courseId + '/viewleads/download',  {
            responseType: 'arraybuffer',
            params} )
    )
}